import { type UseQueryResult, useQuery } from 'react-query';
import {
  AwardAgreementDocumentImportSharedService,
  Wealthlane_AwardService_Dtos_AwardDocumentDto_AwardDocumentDto,
} from '../../services/wealthlane-award-services';

const useGetAwardDocByAwardId = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  id?: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_AwardDocumentDto_AwardDocumentDto[] | undefined,
  unknown
> => {
  const awardDocByAwardId = useQuery(['getAwardDocByAwardId', id], async () => {
    if (id) {
      return await handleRequest(
        AwardAgreementDocumentImportSharedService.getApiAwardApiAppAwardAgreementDocumentImportAwardDocumentsByAwardId(
          id
        )
      );
    }
  });

  return awardDocByAwardId;
};

export default useGetAwardDocByAwardId;
